import logo from './images/logo.jpg'
import noImage from './images/no-image.png'
import defaultAvatar from './images/default-avatar.png'
import particles from './images/particles.png'
import logoDark from './images/registered-capacity-logo.png'
import logoLight from './images/registered-capacity-logo-white.png'
import map from './images/map.png'
import Hexagon from './images/stop_sign.svg'
import Icon from './icon.png'

export default {
  logo,
  noImage,
  defaultAvatar,
  particles,
  logoDark,
  logoLight,
  map,
  Hexagon,
  Icon
}
